/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as UsersActions from '@app/user/store/users.actions';
import { getIsUserActionPending } from '@app/user/store/users.selectors';
import { currentUser } from '@auth/store/auth.selectors';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { User } from '@shared/models';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    standalone: false
})
export class UserProfileComponent implements OnInit {

  user$: Observable<User>;
  isActionPending$: Observable<boolean>;

  userProfileFormGroup = new UntypedFormGroup({
    firstName: new UntypedFormControl('', Validators.required),
    lastName: new UntypedFormControl('', Validators.required),
    email: new UntypedFormControl('', [Validators.email, Validators.required]),
    plainPassword: new UntypedFormControl(''),
  });

  constructor(
    private store: Store<State>,
    @Inject(MAT_DIALOG_DATA) public parameters: { userId: string }
  ) {
  }

  ngOnInit(): void {
    this.user$ = this.store.select(currentUser).pipe(
      tap(user => {
        this.userProfileFormGroup.patchValue(user);
      })
    );
    this.isActionPending$ = this.store.select(getIsUserActionPending);
    this.store.dispatch(new UsersActions.LoadUser(this.parameters.userId));
  }

  persistUser(): void {
    this.store.dispatch(new UsersActions.UpdateAccount(this.userProfileFormGroup.value));
  }
}
